import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "X--sprite",
  "use": "X--sprite-usage",
  "viewBox": "0 0 396 396",
  "content": "<symbol viewBox=\"0 0 396 396\" xmlns=\"http://www.w3.org/2000/svg\" id=\"X--sprite\">\n<path d=\"M301.026 37.125H355.608L236.362 173.415L376.645 358.875H266.805L180.774 246.395L82.335 358.875H27.72L155.265 213.098L20.691 37.125H133.32L211.084 139.937L301.026 37.125ZM281.869 326.205H312.114L116.886 68.079H84.4305L281.869 326.205Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol